import { render, staticRenderFns } from "./WarrantyByProductsBarchart.vue?vue&type=template&id=594253d4"
import script from "./WarrantyByProductsBarchart.vue?vue&type=script&lang=js"
export * from "./WarrantyByProductsBarchart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports